import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { approveProductQuality } from "../../redux/actions/verification";
import { toast } from "react-toastify";
import {
  HiOutlineCheckCircle,
  HiOutlineExclamation,
} from "react-icons/hi";

const QualityApproval = ({ order, onApproved }) => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.verification);
  const [comment, setComment] = useState("");
  const [showForm, setShowForm] = useState(false);

  const isDelivered = order?.status === "Delivered";
  const alreadyApproved = order?.customerApproval?.status === "approved";

  if (!isDelivered || alreadyApproved) {
    if (alreadyApproved) {
      return (
        <div className="bg-green-50 rounded-xl border border-green-200 p-4 mt-4">
          <div className="flex items-center gap-2">
            <HiOutlineCheckCircle className="w-5 h-5 text-green-600" />
            <span className="text-sm font-medium text-green-800">
              You approved the product quality on{" "}
              {new Date(order.customerApproval.approvedAt).toLocaleDateString("en-IN")}
            </span>
          </div>
          {order.customerApproval.comment && (
            <p className="text-xs text-green-700 mt-1 ml-7 italic">
              "{order.customerApproval.comment}"
            </p>
          )}
        </div>
      );
    }
    return null;
  }

  const handleApprove = async (e) => {
    e.preventDefault();
    try {
      await dispatch(approveProductQuality(order._id, comment));
      toast.success("Quality approved! Thank you for confirming.");
      if (onApproved) onApproved();
    } catch {
      toast.error("Failed to submit approval");
    }
  };

  return (
    <div className="bg-blue-50 rounded-xl border border-blue-200 p-4 mt-4">
      <div className="flex items-start gap-2 mb-3">
        <HiOutlineExclamation className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
        <div>
          <p className="text-sm font-medium text-blue-900">
            Confirm Product Quality
          </p>
          <p className="text-xs text-blue-700 mt-0.5">
            Your order has been delivered. Please confirm that the product meets your
            expectations. This helps us process the vendor payment.
          </p>
        </div>
      </div>

      {!showForm ? (
        <button
          onClick={() => setShowForm(true)}
          className="w-full px-4 py-2.5 bg-[#086872] text-white rounded-lg text-sm font-medium hover:bg-[#065a63] transition-colors"
        >
          Approve Product Quality
        </button>
      ) : (
        <form onSubmit={handleApprove} className="space-y-3">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              Comments (optional)
            </label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-[#086872] resize-none"
              rows="2"
              placeholder="Share your feedback..."
            />
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => setShowForm(false)}
              className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-1"
            >
              <HiOutlineCheckCircle className="w-4 h-4" />
              {isLoading ? "Submitting..." : "Confirm Quality"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default QualityApproval;
